import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { environment } from 'environments/environment';

import { PaginatedModel } from '../models/common.models';
import {
	EmailAvailableModel,
	GetClientControlOptionsResponseModel,
	GetClientDetailsResponseModel,
	ICmsUserSearchModel,
	IUserListUserModel,
	RegisterGuestRequestModel,
	RegisterGuestResponseModel,
} from '../models/user-management.models';

@Injectable({
	providedIn: 'root',
})
export class UserManagementService {
	private searchEvent = new Subject<any>();
	private clientAccountDetailsPromise: Promise<GetClientDetailsResponseModel>;
	private clientControlOptionsPromise: Promise<GetClientControlOptionsResponseModel>;

	searchEvent$ = this.searchEvent.asObservable();

	private get baseApiUrl(): string {
		return environment.userManagementUrl;
	}

	constructor(private http: HttpClient) {}

	// TODO This is a test method to test api request to microservice
	getCmsUsersV1(searchModel: ICmsUserSearchModel): Observable<PaginatedModel<IUserListUserModel>> {
		const url = `${this.baseApiUrl}/v1/cmsusers`;
		let params = new HttpParams()
			.append('filterText', searchModel.searchText)
			.append('orderByColumn', searchModel.orderByColumn)
			.append('orderByDirection', searchModel.orderByDirection)
			.append('page', searchModel.page.toString())
			.append('pageSize', searchModel.pageSize.toString());

		if (searchModel.status) {
			params = params.append('status', searchModel.status);
		}

		return this.http.get<PaginatedModel<IUserListUserModel>>(url, {
			params,
		});
	}

	getClientAccountDetailsV1(): Observable<GetClientDetailsResponseModel> {
		const url = `${this.baseApiUrl}/v1/WinePortal/client`;
		return this.http.get<GetClientDetailsResponseModel>(url, {});
	}

	clientAccountDetails(): Promise<GetClientDetailsResponseModel> {
		if (!this.clientAccountDetailsPromise) {
			this.clientAccountDetailsPromise = this.getClientAccountDetailsV1()
				.toPromise()
				.catch(() => null);
		}

		return this.clientAccountDetailsPromise;
	}

	getClientControlOptionsV1(): Observable<GetClientControlOptionsResponseModel> {
		const url = `${this.baseApiUrl}/v1/WinePortal/client/controlOptions`;
		return this.http.get<GetClientControlOptionsResponseModel>(url, {});
	}

	clientControlOptions(): Promise<GetClientControlOptionsResponseModel> {
		if (!this.clientControlOptionsPromise) {
			this.clientControlOptionsPromise = this.getClientControlOptionsV1()
				.toPromise()
				.catch(() => null);
		}

		return this.clientControlOptionsPromise;
	}

	createGuestAccountV1(model: RegisterGuestRequestModel): Observable<RegisterGuestResponseModel> {
		const url = `${environment.authUrl}/signup/guest`;
		return this.http.post<RegisterGuestResponseModel>(url, model);
	}

	getIsEmailAvailable(email: string): Observable<EmailAvailableModel> {
		const url = `${this.baseApiUrl}/v1/WinePortal/guest/available`;

		const params = new HttpParams().append('email', email);

		return this.http.get<EmailAvailableModel>(url, { params });
	}
}
